<template>
  <app-layout
    title="Profile"
    v-bind="$page.props">
    <template #header>
      <h2 class="font-semibold text-xl text-gray-800 leading-tight">
        問題情報管理
      </h2>
    </template>
    <div class="max-w-7xl mx-auto py-10 sm:px-6 lg:px-8">
      <div class="grid grid-cols-12 gap-4">
        <div class="col-span-3 flex-col">
          <div>
            <subject-menu
              :subjects="subjects"
              :selected-subject="subject" />
          </div>
        </div>
        <div class="col-span-9">
          <div class="flex flex-row-reverse items-center">
            <button
              class="px-8 py-2 rounded bg-blue-600 text-blue-50 max-w-max shadow-sm hover:shadow-lg"
              @click.prevent="onCreateClicked">
              新規作成
            </button>
            <button
              class="mr-2 px-8 py-2 rounded bg-green-500 text-white max-w-max shadow-sm hover:shadow-lg"
              @click.prevent="show = true">
              選択した問題を模試に追加
            </button>
          </div>
          <div class="grid grid-cols-3 py-2 text-gray-600">
            <div class="col-span-3">
              PerPage:
              <select
                :value="paginatePerPage"
                class="ml-2 pl-2 rounded border-gray-400"
                @change="onChangedPerPage">
                <option
                  v-for="(n, i) in paginatePerPages"
                  :key="i">
                  {{ n }}
                </option>
              </select>
            </div>
          </div>
          <div class="grid grid-cols-12 mb-4">
            <input
              v-model="idForm.question_id"
              type="search"
              class="col-span-2 form-input border border-gray-300 outline-none rounded-md py-2 px-4 bg-white placeholder-gray-400 text-gray-500 appearance-none w-full block focus:outline-none"
              placeholder="ID" />
            <button
              class="col-span-2 relative ml-6 px-6 py-2 rounded bg-blue-600 text-blue-50 max-w-max shadow-sm hover:shadow-lg"
              @click.prevent="onSearchById">
              <svg
                class="absolute pointer-events-none w-6 h-6 top-1/4 left-1/4 text-white"
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24">
                <path
                  d="M16.32 14.9l5.39 5.4a1 1 0 0 1-1.42 1.4l-5.38-5.38a8 8 0 1 1 1.41-1.41zM10 16a6 6 0 1 0 0-12 6 6 0 0 0 0 12z" />
              </svg>
            </button>
          </div>
          <div class="grid grid-cols-12 mb-4">
            <input
              v-model="form.subjectKeyword"
              type="search"
              class="col-span-2 form-input border border-gray-300 outline-none rounded-md py-2 px-4 bg-white placeholder-gray-400 text-gray-500 appearance-none w-full block focus:outline-none"
              placeholder="分野" />
            <input
              v-model="form.questionKeyword"
              type="search"
              class="col-span-3 ml-2 form-input border border-gray-300 outline-none rounded-md py-2 px-4 bg-white placeholder-gray-400 text-gray-500 appearance-none w-full block focus:outline-none"
              placeholder="問題文" />
            <input
              v-model="form.correctAnswerKeyword"
              type="search"
              class="col-span-2 ml-4 form-input border border-gray-300 outline-none rounded-md py-2 px-4 bg-white placeholder-gray-400 text-gray-500 appearance-none w-full block focus:outline-none"
              placeholder="正答" />
            <button
              class="col-span-1 relative ml-6 px-6 py-2 rounded bg-blue-600 text-blue-50 max-w-max shadow-sm hover:shadow-lg"
              @click.prevent="onSearchButtonClicked">
              <svg
                class="absolute pointer-events-none w-6 h-6 top-1/4 left-1/4 text-white"
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24">
                <path
                  d="M16.32 14.9l5.39 5.4a1 1 0 0 1-1.42 1.4l-5.38-5.38a8 8 0 1 1 1.41-1.41zM10 16a6 6 0 1 0 0-12 6 6 0 0 0 0 12z" />
              </svg>
            </button>
            <button
              class="col-span-2 bg-white hover:bg-gray-100 text-black ml-4 py-2 px-1 border border-gray-200 rounded shadow"
              @click.prevent="onResetButtonClicked">
              リセット
            </button>
          </div>
          <div class="flex mb-4">
            <input
              id="all_subject"
              v-model="isAllSubject"
              type="checkbox"
              class="w-4 mr-3 rounded border-gray-300 text-indigo-600 shadow-sm focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50"
              autofocus />
            <p
              class="block font-medium text-sm text-gray-700">
              全科目を対象とする
            </p>
          </div>
          <question-list
            :pagination="pagination"
            :subject="subject"
            :limit="limit"
            :subject-keyword="props.subjectKeyword"
            :question-keyword="props.questionKeyword"
            :correct-answer-keyword="props.correctAnswerKeyword"
            :is-all-subject="isAllSubject"
            @select-questions="state.selectedQuestions = $event" />
        </div>
      </div>
    </div>
    <dialog-modal
      :show="show"
      max-width="lg"
      @close="show = !show">
      <template #title>
        選択した問題を模試に追加する
      </template>
      <template #content>
        <div class="w-full px-4">
          <p
            v-if="!state.selectedQuestions.length > 0"
            :class="{'text-red-600' : !state.selectedQuestions.length > 0}"
            class=" pl-4 text-md">
            最初に一覧画面から問題を選択してください。
          </p>
          <div
            v-for="(examination, index) in props.examinations"
            :key="examination.id"
            class="w-full max-w-md p-2 mx-auto bg-white rounded-2xl">
            <Disclosure>
              <DisclosureButton
                class="flex justify-between w-full px-4 py-2 text-sm font-medium text-left text-purple-900 bg-purple-100 rounded-lg hover:bg-purple-200 focus:outline-none focus-visible:ring focus-visible:ring-purple-500 focus-visible:ring-opacity-75"
                @click="onInitializeExaminationType(examination.id)">
                <div class="flex content-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor">
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
                  </svg>
                  <span class="inline-block pt-1 pl-4">{{ examination.title }}</span>
                </div>
              </DisclosureButton>
              <DisclosurePanel
                class="px-4 pt-4 pb-2 text-sm text-gray-500">
                <div class="flex text-black">
                  <div
                    v-for="(type, key) in examinationTypes"
                    :key="key"
                    class="px-2">
                    <label
                      class="inline-flex items-center">
                      <input
                        :checked="false"
                        type="radio"
                        :value="key"
                        :disabled="isLimitQuestionCount(examination.id, key)"
                        class="form-radio mx-2"
                        :name="`radio${index}`"
                        @change="changedRadioValue($event.target.value, examination)" />
                      {{ type }}
                    </label>
                  </div>
                </div>
              </DisclosurePanel>
            </Disclosure>
          </div>
        </div>
      </template>
      <template #footer>
        <white-button
          class="mr-4 bg-white text-black"
          @click="show = !show">
          キャンセル
        </white-button>
        <button
          :disabled="!state.selectedQuestions.length || !state.selectedExaminations.length"
          :class="[state.selectedQuestions.length && state.selectedExaminations.length ? 'bg-blue-600 text-blue-50' : 'bg-gray-400 text-white cursor-not-allowed']"
          class="px-8 py-2 bg-blue-600 text-blue-50 rounded max-w-max shadow-sm hover:shadow-lg"
          @click="onAddExaminationClicked">
          追加
        </button>
      </template>
    </dialog-modal>
  </app-layout>
</template>

<script setup>
import { Inertia } from '@inertiajs/inertia'
import Swal from 'sweetalert2'
import {
  reactive, ref, onMounted, computed,
} from 'vue'
import {
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
} from '@headlessui/vue'
import AppLayout from '@/Layouts/AppLayout'
import SubjectMenu from './Partials/SubjectMenu'
import ExaminationMenu from './Partials/ExaminationMenu'
import DialogModal from '../../Common/DialogModal'
import WhiteButton from '../../Common/Button'
import QuestionList from './Partials/QuestionList'

const props = defineProps({
  subjects: {
    type: Array,
    default: () => [],
  },
  subject: {
    type: Object,
    default: () => {
    },
  },
  pagination: {
    type: Object,
    default: () => {
    },
  },
  subjectKeyword: {
    type: String,
    default: null,
  },
  questionKeyword: {
    type: String,
    default: null,
  },
  correctAnswerKeyword: {
    type: String,
    default: null,
  },
  examinations: {
    type: Array,
    default: () => ([]),
  },
  examinationTypes: {
    type: Object,
    required: true,
  },
  countExaminationQuestions: {
    type: Array,
    default: () => [],
  },
  limit: {
    type: String,
    default: '10',
  },
  examinationTypesMaxQuestionCount: {
    type: Object,
    default: () => {},
  },
  isAllSubject: {
    type: Boolean,
    default: false,
  },
  flash: {
    type: Object,
    default: () => ({}),
  },
})

const form = reactive(Inertia.form({
  subjectKeyword: props.subjectKeyword,
  questionKeyword: props.questionKeyword,
  correctAnswerKeyword: props.correctAnswerKeyword,
}))

const show = ref(false)

const isAllSubject = ref(props.isAllSubject)

const paginatePerPage = ref('15')
const paginatePerPages = ['5', '10', '15', '30', '50', '100']
const onChangedPerPage = (e) => {
  Inertia.get(route('questions', {
    subject: props.subject,
    page: '1',
    limit: e.target.value,
  }, {
    only: ['pagination'],
  }))
}

const state = reactive({
  selectedQuestions: [],
  selectedExaminations: [],
})

const changedRadioValue = (e, examination) => {
  const index = state.selectedExaminations.findIndex((item) => item.id === examination.id)
  if (index > -1) {
    state.selectedExaminations.splice(index, 1, {
      id: examination.id,
      type: e,
    })
  } else {
    state.selectedExaminations.push({
      id: examination.id,
      type: e,
    })
  }
}
const onInitializeExaminationType = (examinationId) => {
  const index = state.selectedExaminations.findIndex((item) => item.id === examinationId)
  if (index > -1) {
    state.selectedExaminations.splice(index, 1)
  }
}
const onCreateClicked = () => {
  Inertia.get(route('questions.create', { subject: props.subject }))
}

const onAddExaminationClicked = () => {
  Inertia.post(route('questions.addExamination', {
    subject: props.subject.id,
    examinations: state.selectedExaminations,
    questions: state.selectedQuestions,
  }))
  show.value = false
}

const onSearchButtonClicked = () => {
  Inertia.get(route('questions', {
    subjectKeyword: form.subjectKeyword,
    questionKeyword: form.questionKeyword,
    correctAnswerKeyword: form.correctAnswerKeyword,
    subject: props.subject,
    limit: props.limit,
    isAllSubject: isAllSubject.value,
  }, {
    only: ['pagination'],
  }))
}

const onResetButtonClicked = () => {
  form.subjectKeyword = ''
  form.questionKeyword = ''
  form.correctAnswerKeyword = ''
  Inertia.get(route('questions', {
    subject: props.subject,
    limit: props.limit,
  }, {
    only: ['pagination'],
  }))
}

onMounted(() => {
  paginatePerPage.value = props.pagination.per_page
})

const isLimitQuestionCount = computed(() => (id, key) => {
  const examinationQuestion = props.countExaminationQuestions.find((item) => item.examination_id === id && item.examination_type === Number(key))

  if (!examinationQuestion) return false

  return !(examinationQuestion.question_count < props.examinationTypesMaxQuestionCount[examinationQuestion.examination_type])
})

const idForm = reactive(Inertia.form({
  question_id: null,
}))

const onSearchById = () => {
  idForm.get(route('questions.searchById'))
}
</script>
